import { SearchParams } from 'algoliasearch'
import client from '.'
import { MediaIndex, UserIndex } from '@/interfaces/algolia'

const defaultSearchParams: SearchParams = {
  enableReRanking: true,
}

export const searchUser = async ({
  query = '',
  page = 1,
  hitsPerPage = 20,
  userId,
}: {
  query: string,
  page?: number,
  hitsPerPage?: number,
  userId?: string,
}): Promise<UserIndex[]> => {
  // if (!query) {
  //   return []
  // }
  const result = await client.searchSingleIndex({ indexName: 'users', searchParams: {
    ...defaultSearchParams,
    userToken: userId && `user-${userId}`,
    query,
    page: page - 1,
    hitsPerPage,
  }})
  return result.hits
}

export const searchMedia = async ({
  query = '',
  page = 1,
  hitsPerPage = 20,
  userId,
}: {
  query: string,
  page?: number,
  hitsPerPage?: number,
  userId?: string,
}): Promise<MediaIndex[]> => {
  // if (!query) {
  //   return []
  // }
  const result = await client.searchSingleIndex({ indexName: 'media', searchParams: {
    ...defaultSearchParams,
    userToken: userId && `user-${userId}`,
    query,
    page: page - 1,
    hitsPerPage,
  }})
  return result.hits
}

export const searchSound = async ({
  query = '',
  page = 1,
  hitsPerPage = 20,
  userId,
}: {
  query: string,
  page?: number,
  hitsPerPage?: number,
  userId?: string,
}): Promise<MediaIndex[]> => {
  // if (!query) {
  //   return []
  // }
  const result = await client.searchSingleIndex({ indexName: 'media', searchParams: {
    ...defaultSearchParams,
    userToken: userId && `user-${userId}`,
    query,
    page: page - 1,
    hitsPerPage,
    facetFilters: [ 'mediaType:sound' ],
  }})
  return result.hits
}
